function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M160.08,153.443,41.715,36.1839,28.44,49.4585,76.0077,97.0259v3.3186a59.3839,59.3839,0,0,0,47.5674,58.63v82.9664h24.3368V167.8239l45.355,45.3549,21.0181,22.1244L227.56,222.0286,160.08,153.443Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M175.5674,142.3808c11.0622-11.0621,17.7-25.443,17.7-42.0363V79.3264h-19.912V26.2279a12.1684,12.1684,0,1,0-24.3368,0V79.3264H118.044V26.2279a12.1684,12.1684,0,1,0-24.3368,0v35.399Z"
});

var SvgWebappIconUnpluggedLightTheme = function SvgWebappIconUnpluggedLightTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconUnpluggedLightTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-unplugged-light-theme.f6005998.svg";
export { ForwardRef as ReactComponent };